<template>
  <div id="teacher_journal">
    <div class="over_ta">
      <ul style="margin-top: 20px;">
        <li style="list-style: inside;" v-for="(teacherpublication,index) in teacherpublications" :key="index" v-if="teacherpublication.type === 2">
          <span v-if="teacherpublication.context">
            {{teacherpublication.context}}
          </span> 
          <span v-else>
            <div style="display: inline-block" aria-hidden="true" v-html="(teacherpublication.author)">
            </div>, {{publication(teacherpublication)}},
            <div style="display: inline-block" aria-hidden="true" v-html="(teacherpublication.title)">
            </div>, {{showName(teacherpublication)}}, {{showIssueNumber(teacherpublication)}}, {{teacherpublication.pageS}} ~ {{teacherpublication.pageE}}, <span v-if="teacherpublication.memo">({{teacherpublication.memo}})</span>
          </span>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import axios from 'axios';
import { API, Message, ShowPage } from '@/assets/project_setting/config';
import { GetErrorHandler, ShowMessage } from '@/assets/library/axiosErrorHandler';

export default {
  name: 'teacher_journal',
  props: ['teacher', 'teacherpublications'],
  data() {
    return {
      info: {},
      showPage: ShowPage(sessionStorage.getItem('locale')),
    };
  },
  created() {},
  methods: {
    publication(teacherpublication) {
      if (teacherpublication.publicationAt) {
        let dateArr = teacherpublication.publicationAt.split(' ')[0].split('-');
        return dateArr[0]
      }
      return ''
    },
    

    showName(teacherpublication) {
      let name = { 'CH': teacherpublication.nameCh, 'EN': teacherpublication.nameEn }
      return name[sessionStorage.locale];
    },
    showIssueNumber(teacherpublication) {
      let show = {
        CH: `第 ${teacherpublication.journal} 期，第 ${teacherpublication.journalUnit} 單元`,
        EN: `Vol. ${teacherpublication.journal} No. ${teacherpublication.journalUnit}`
      }
      return show[sessionStorage.locale];
    },
  },
}

</script>
<style lang="scss">
#teacher_journal {
  table {
    tr {
      td {
        padding: 10px;
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// TeacherJournal.vue?3528e494